module.exports = __webpack_public_path__ + "img/FreelancerFeaturesTablet.be493b5d.webp";